import React from 'react';
import gql from 'graphql-tag';
import useMutation from '../../modules/react/hooks/useMutation';
import Component from '../components/IntegrationTable';

export const INTEGRATION_ALERT_UPDATE = gql`
  mutation IntegrationAlertUpdate(
    $id: ID!,
    $alert: IntegrationAlertUpdateInput!
  ) {
    integrationAlertUpdate(id: $id, alert: $alert) {
      integration {
        id
        ...IntegrationTableIntegrationFields
      }
    }
  }

  ${Component.fragments.integration}
`;

const IntegrationTable = ({ integration }) => {
  const [integrationAlertUpdate, { data }] = useMutation(
    INTEGRATION_ALERT_UPDATE,
  );

  const mutate = ({
    active,
    context,
    defaultMessage,
    message,
  }) => integrationAlertUpdate({
    variables: {
      id: integration.id,
      alert: { active, context, defaultMessage, message },
    },
  });

  const handleAlertContextChange = context => mutate({
    ...integration.alert,
    context,
  });

  const handleAlertStatusChange = active => mutate({
    ...integration.alert,
    active,
  });

  const handleCurrentAlertChange = message => mutate({
    ...integration.alert,
    message,
  });

  const handleDefaultAlertChange = message => mutate({
    ...integration.alert,
    defaultMessage: message,
  });

  const {
    integrationAlertUpdate: {
      integration: mutatedIntegration,
    } = {},
  } = data || {};

  const integrationToUse = mutatedIntegration || integration;

  return (
    <Component
      integration={integrationToUse}
      onChangeAlertContext={handleAlertContextChange}
      onChangeAlertStatus={handleAlertStatusChange}
      onChangeCurrentAlert={handleCurrentAlertChange}
      onChangeDefaultAlert={handleDefaultAlertChange}
    />
  );
};

IntegrationTable.fragments = {
  integration: gql`
    fragment IntegrationTableIntegration on Integration {
      id
      ...IntegrationTableIntegrationFields
    }

    ${Component.fragments.integration}
  `,
};

export default IntegrationTable;
